export const INITIALIZE = 'app/INITIALIZE_REQUEST';
export const INITIALIZE_SUCCESS = 'app/INITIALIZE_SUCCESS';
export const PROCESS_CLASSES = 'app/PROCESS_CLASSES';
export const FINISHES = 'app/FINISHES';
export const ERROR = 'app/ERROR';
export const BLANK = 'app/BLANK';
export const SET_IS_LOADED = 'app/SET_IS_LOADED';
export const SET_IS_FETCHING = 'app/SET_IS_FETCHING';
export const PAGE_REQUEST = 'app/PAGE_REQUEST';
export const PAGE_SUCCESS = 'app/PAGE_SUCCESS';
export const PAGE_ERROR = 'app/PAGE_ERROR';
export const PAGE_PENDING_START = 'app/PAGE_PENDING_START';
export const PAGE_PENDING_FINISH = 'app/PAGE_PENDING_FINISH';
export const LOCATION_CHANGE = 'app/LOCATION_CHANGE';
export const USER_SESSION_EXPIRED = 'app/USER_SESSION_EXPIRED';
